<script lang="ts">
	let {
		src = '',
		alt = '',
		width = 'auto',
		height = 'auto',
		class: className = '',
		wrapperClass = '',
		loading = 'lazy'
	}: {
		src: string;
		alt: string;
		width: string;
		height: string;
		class: string;
		wrapperClass: string;
		loading: 'lazy' | 'eager';
	} = $props();
</script>

<div class="relative min-h-0 w-full {wrapperClass}">
	<img {src} {alt} {width} {height} class="object-cover {className}" {loading} />
</div>
